import { IonButton } from '@ionic/react';
import classNames from 'classnames';
import { PublicSiteInformation } from 'model';
import AboutBusinessImage from '../assets/about/business.jpg';
import AboutEventImage from '../assets/about/event.jpg';
import AboutPollImage from '../assets/about/poll.jpg';
import AboutPostImage from '../assets/about/post.jpg';
import AboutImage from '../assets/aboutGraphic.jpg';
import { siteSettingsTextReplacements } from '../util/siteSettingsTextReplacements';
import { SiteIcon } from './SiteIcon';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './GettingStartedPages.module.css';
import { PostContentsToHTML } from './PostContentsToHTML';
import { IconBusiness, IconCalendar } from './QuirkIcons';
export const getPages = (
	siteSettings: PublicSiteInformation | undefined,
	handleClick: (index: number) => void,
	tabs?: boolean
) => [
	{
		component: (
			<div className={tabs ? styles.aboutPage : styles.experiencePage}>
				<div className={styles.contentWrapper}>
					<div className="center-align">
						<SiteIcon size={90} />
					</div>
					<div className={classNames('center-align', styles.introText)}>
						<h4 className="bold">Welcome to {siteSettings?.siteName}</h4>
						{siteSettings?.description}
					</div>
					<div className={classNames('center-align', styles.introText)}>
						<IonButton onClick={() => handleClick(1)}>Start the tour</IonButton>
					</div>
				</div>
				<div className={styles.aboutImageContainer}>
					<div className={styles.aboutImage}>
						<img src={AboutImage} alt={'About'} />
					</div>
				</div>
			</div>
		)
	},
	{
		component: (
			<div className={tabs ? styles.aboutPage : styles.experiencePage}>
				<div className={styles.contentWithScroll}>
					<PostContentsToHTML>
						{siteSettingsTextReplacements(siteSettings, siteSettings?.gettingStarted as string)}
					</PostContentsToHTML>
					<div className={classNames('center-align', styles.introText)}>
						<IonButton onClick={() => handleClick(2)}>See features</IonButton>
					</div>
				</div>
			</div>
		)
	},
	{
		component: (
			<div className={tabs ? styles.aboutPage : styles.experiencePage}>
				<div className={classNames(styles.contentWithScroll, styles.centerWrap)}>
					<h3 className="center-align bold">Community Posts</h3>
					<div>
						Rich and vibrant posts with multiple photo uploads and text formatting to help your
						contributions stand out.
					</div>
					<div className={styles.featureImage}>
						<img src={AboutPostImage} alt={'Post'} />
					</div>
				</div>
			</div>
		)
	},
	{
		component: (
			<div className={tabs ? styles.aboutPage : styles.experiencePage}>
				<div className={classNames(styles.contentWithScroll, styles.centerWrap)}>
					<h3 className="center-align bold">Community opinions</h3>
					<div>Take the pulse of the community on local issues with flexible and secure polling.</div>
					<div className={styles.featureImage}>
						<img src={AboutPollImage} alt={'Post'} />
					</div>
				</div>
			</div>
		)
	},
	{
		component: (
			<div className={tabs ? styles.aboutPage : styles.experiencePage}>
				<div className={classNames(styles.contentWithScroll, styles.centerWrap, styles.inlineSVG)}>
					<h3 className="center-align bold">Keep track of local events</h3>
					<div>
						Select the calendar tab <IconCalendar size={20} /> below and stay on top of what’s going on in
						the months ahead with a rich event calendar.
					</div>
					<div className={styles.featureImage}>
						<img src={AboutEventImage} alt={'Event'} />
					</div>
				</div>
			</div>
		)
	},
	{
		component: (
			<div className={tabs ? styles.aboutPage : styles.experiencePage}>
				<div className={classNames(styles.contentWithScroll, styles.centerWrap, styles.inlineSVG)}>
					<h3 className="center-align bold">Business Directory</h3>
					<div>
						Select the business tab <IconBusiness size={20} /> below and search for local businesses with
						products and services you need. Shop Local!
					</div>
					<div className={styles.featureImage}>
						<img src={AboutBusinessImage} alt={'Event'} />
					</div>
				</div>
			</div>
		)
	}
];
